import { BaseApiResponse } from '../../types';
import { PinnedScreens } from './types';
import { simpleQueryServerData } from '../simpleQueryServerData';

export async function updateShortcuts(
    pinnedScreens: PinnedScreens
): Promise<BaseApiResponse<null>> {
    return simpleQueryServerData('api_react/src/menu/updateShortcuts.php', 'POST', pinnedScreens);
}
